export default __webpack_public_path__ + "static/media/icon.b3545ae4.png";